import {
  normalizeProvisionalAgreementData,
  getTermsAndConditions,
} from '../normalizers/uiNeeds';
import { commonTypes } from '../common';

export const types = {
  SET_PRICES_INFO: 'UINEEDS/SET_PRICES_INFO',
  SET_PROVISIONAL_AGREEMENT_DATA: 'UINEEDS/SET_PROVISIONAL_AGREEMENT_DATA',
};

export const initialState = {
  productOfferingsToBuyInfo: {},
  legalTerms: {},
  pricesInfo: null,
  provisionalAgreementData: null,
};

const UINeedsOfferReducer = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_LEGAL_TERMS_INFO: {
      const { termsAndConditions, documents, phoneNumbersOTP } = action.payload;
      const { legalTerms: actualLegalTerms } = state;
      const { termsAndConditions: actualTermsAndConditions } = { ...actualLegalTerms };
      const termsToAppend = getTermsAndConditions(termsAndConditions);
      const newState = { ...state };
      newState.legalTerms = {
        termsAndConditions: `${actualTermsAndConditions || ''}${termsToAppend || ''}`,
        showDefaultProductOfferingTerms: !termsToAppend,
        documents,
        termsObtained: true,
        phoneNumbersOTP,
      };
      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    case commonTypes.SET_PRODUCT_OFFERING_INFO: {
      const { productOfferingName, productOfferingBriefText, productOfferingShortText, productOfferingId } = action.payload;

      let newProductOfferingInfo = {
        ...state.productOfferingsToBuyInfo[productOfferingId],
      };
      if (productOfferingName) {
        newProductOfferingInfo = {
          ...newProductOfferingInfo,
          productOfferingName,
        };
      }
      if (productOfferingBriefText) {
        newProductOfferingInfo = {
          ...newProductOfferingInfo,
          productOfferingBriefText,
        };
      }
      if (productOfferingShortText) {
        newProductOfferingInfo = {
          ...newProductOfferingInfo,
          productOfferingShortText,
        };
      }

      const newState = {
        ...state,
        productOfferingsToBuyInfo: {
          ...state.productOfferingsToBuyInfo,
          [productOfferingId]: { ...newProductOfferingInfo },
        },
      };

      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    case types.SET_PRICES_INFO: {
      const {
        recurringCharges,
        oneTimeCharges,
        termsAndConditions,
        taxName,
        haveMaintainingPromo,
      } = action.payload;

      if (recurringCharges && oneTimeCharges) {
        const newState = {
          ...state,
          pricesInfo: { recurringCharges, oneTimeCharges, taxName, haveMaintainingPromo },
          legalTerms: {
            termsAndConditions,
          },
        };

        return {
          state: newState,
          stepsMustBeEvaluated: true,
        };
      }

      return null;
    }
    case commonTypes.SET_PRICES_CHANGE_INFO: {
      if (action.payload) {
        const newState = {
          ...state,
          priceChange: action.payload,
        };

        return {
          state: newState,
          stepsMustBeEvaluated: false,
        };
      }

      return null;
    }
    case types.SET_PROVISIONAL_AGREEMENT_DATA: {
      const { agreementApplies, attachments } = action.payload;

      const newState = {
        ...state,
      }
      if(!newState.provisionalAgreementData){
        newState.provisionalAgreementData = normalizeProvisionalAgreementData(agreementApplies, attachments);
      }

      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    default:
      return null;
  }
};

export const actions = {
  setPricesInfo: info => ({
    type: types.SET_PRICES_INFO,
    payload: {
      ...info,
    },
  }),
  setProvisionalAgreementData: info => ({
    type: types.SET_PROVISIONAL_AGREEMENT_DATA,
    payload: {
      ...info,
    },
  }),
};

export default UINeedsOfferReducer;
